import { Injectable } from '@angular/core';
import { Option } from '../../modules/core/models/option.model'; 
import { ApiCallHandler } from '../../modules/core/models/apiCallHandler';
import { EoHttpClient, IHttpParams } from 'ngx-eo-web-components';
import { CoreService } from '../../modules/core/core.service';

@Injectable({
  providedIn: 'root',
})
export class OptionService {

  public optionListCallHandler = new ApiCallHandler<Option[]>();

  constructor(
    private http: EoHttpClient,
    private coreService: CoreService
  ) {}

  init() {
    this.optionListCallHandler.init([]);
  }

  getOptions(type: string) {
    const param: IHttpParams = this.coreService.initCall(
      `/v1/Options/list/${type}`,
      this.optionListCallHandler
    );

    return this.http.get<Option[]>(param);
  }

}
